import PointStore from "@/pages/store/PointStore.vue"
import { MainLayout, SimpleLayout } from "@/layouts"
import store from "@/store/index.store"
import { ROUTER_NAMES } from "@/constants/router.constants"
import GoPro from "@/pages/store/GoPro.vue"
import Redeem from "@/pages/store/Redeem.vue"

export default [
  {
    path: "/store/points",
    name: ROUTER_NAMES.POINT_STORE,
    component: PointStore,
    meta: {
      layout: {
        component: MainLayout,
      },
    },
    beforeEnter: async (_to, from, next) => {
      try {
        await store.dispatch("User/loadUser")
        next()
      } catch (error) {
        next()
      }
    },
  },
  {
    path: "/store/subscriptions",
    name: ROUTER_NAMES.SUBSCRIPTION,
    component: GoPro,
    beforeEnter: async (_to, from, next) => {
      try {
        await Promise.all([
          store.dispatch("Store/getSubscriptionOptions"),
          store.dispatch("User/loadUser"),
        ])
        const user = store.getters["User/getUser"]

        if (user) {
          await Promise.all([
            store.dispatch("User/loadUserActiveGames"),
            store.dispatch("User/Subscriptions/loadUserSubscriptions"),
          ])
        }

        next()
      } catch (error) {
        console.error(error)
        next()
      }
    },
  },
  {
    path: "/redeem",
    name: ROUTER_NAMES.PRODUCT_CODE_REDEMPTION,
    component: Redeem,
    meta: {
      layout: {
        component: SimpleLayout,
      },
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/store.routes.js